// extracted by mini-css-extract-plugin
module.exports = {"Wizard":"CharacterWizard_Wizard__1KKx8","LeftAlign":"CharacterWizard_LeftAlign__4FJlz","BottomMargin":"CharacterWizard_BottomMargin__1LHP4"};